<template>
<div>
  <app-menu :menuItems="menuItems" v-on:action="$emit('action', $event)">
    <template v-slot:before>
    <div class="user-search">
      <a class="search" href="" v-on:click.prevent="searchOpen=!searchOpen">Search</a>
    </div>
    </template>
    <div class="user-cart" v-if="true || $parent.$parent.loggedIn">
      <a class="cart" href="" v-on:click.prevent="cartOpen=!cartOpen">Cart
        <span v-if="cart.cartItems && cart.cartItems.length">{{ cart.cartItems.length }}</span>
      </a>
    </div>
    <div class="user-controls">
      <div class="out" v-if="!$parent.$parent.loggedIn">
        <a href="" v-on:click.prevent="actionRegister" class="navlink">Register</a>
        <a href="" v-on:click.prevent="actionLogin" class="navlink">Login</a>
      </div>
      <div class="in" v-else>
        <a href="" v-on:click.prevent="actionProfile" class="navlink">Profile</a>
        <router-link v-if="isAdmin" :to="{name: 'admin.posts'}" class="navlink navadmin">Admin</router-link>
        <a href="" v-on:click.prevent="actionLogout" class="navlink">Logout</a>
      </div>
    </div>
  </app-menu>
  <div class="pop-pane pop-pane-center">
    <transition name="pop-pane">
    <user-register class="register" v-if="currentPane=='register'" />
    <user-login class="login" v-else-if="currentPane=='login'" />
    <user-profile class="profile" v-else-if="currentPane=='profile'" />
    </transition>
  </div>
  <div class="pop-pane pop-pane-right">
    <transition name="pop-pane">
    <cart v-show="cartOpen" />
    </transition>
  </div>
  <div class="pop-pane pop-pane-left" >
    <transition name="pop-pane">
    <search v-show="searchOpen" />
    </transition>
  </div>
</div>
</template>

<script>
export default {
  props: ["menuItems"],
  data: ()=>({
    currentPane: null,
    cartOpen: false,
    searchOpen: false,
    cart: {},
  }),
  computed: {
    isAdmin() {
      return this.$parent.$parent.loggedIn && this.$parent.$parent.loggedIn.admin;
    },
  },
  methods: {
    actionRegister() {
      if (this.currentPane!="register")
        this.currentPane="register";
      else 
        this.currentPane=null;
    },
    actionLogin() {
      if (this.currentPane!="login")
        this.currentPane="login";
      else 
        this.currentPane=null;
    },
    actionProfile() {
      if (this.currentPane!="profile")
        this.currentPane="profile";
      else 
        this.currentPane=null;
    },
    async actionLogout() {
      this.currentPane=null;
      await api.logout();
      this.$router.push({name: "home"});
    },
  },
  created() {
    window.appHeadNav=this;
    this.$nextTick(()=>{
      this.cart=window.appCart;
    });
  },
}
</script>
